import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getBlogBySlug, getRelatedBlogs } from '../../services/blogService';
import './BlogPost.css';
import '../Blog/BlogList.css';

const fmtDate = (ts) => {
  if (!ts) return '';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });
};

export default function BlogPost() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getBlogBySlug(slug).then(async (data) => {
      setBlog(data);
      setLoading(false);
      if (data?.category) {
        const rel = await getRelatedBlogs(data.category, slug, 3);
        setRelated(rel);
      }
    });
  }, [slug]);

  if (loading) return <div className="blog-post-loading">Loading…</div>;

  if (!blog) return (
    <div className="blog-post-notfound">
      <h2>Post not found</h2>
      <p>This post may have been removed or the link is incorrect.</p>
      <Link to="/blog">← Back to Blog</Link>
    </div>
  );

  return (
    <div className="blog-post-page">
      {blog.coverImage ? (
        <div className="blog-post-hero">
          <img src={blog.coverImage} alt={blog.title} />
          <div className="blog-post-hero-overlay" />
          <div className="blog-post-hero-title">
            {blog.category && <span className="blog-category">{blog.category}</span>}
            <h1>{blog.title}</h1>
          </div>
        </div>
      ) : (
        <div className="blog-post-no-cover">
          {blog.category && <span className="blog-category">{blog.category}</span>}
          <h1>{blog.title}</h1>
        </div>
      )}

      <div className="blog-post-meta-bar">
        <span className="blog-date">{fmtDate(blog.publishedAt)}</span>
        <Link to="/blog" className="blog-post-back">← All Posts</Link>
      </div>

      <div className="blog-post-body">
        {blog.excerpt && <p className="blog-post-excerpt">{blog.excerpt}</p>}
        <div
          className="blog-post-content"
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />
      </div>

      <div className="blog-post-footer">
        <Link to="/blog" className="blog-post-footer-link">← Back to Blog</Link>
      </div>

      {related.length > 0 && (
        <div className="blog-related">
          <h2>You might also like</h2>
          <div className="blog-related-grid">
            {related.map(b => (
              <Link key={b.id} to={`/blog/${b.slug}`} className="blog-card">
                {b.coverImage
                  ? <img src={b.coverImage} alt={b.title} className="blog-card-cover" />
                  : <div className="blog-card-cover-placeholder">✨</div>
                }
                <div className="blog-card-body">
                  <div className="blog-card-meta">
                    {b.category && <span className="blog-category">{b.category}</span>}
                    <span className="blog-date">{fmtDate(b.publishedAt)}</span>
                  </div>
                  <h2 className="blog-card-title">{b.title}</h2>
                  <span className="blog-read-more">Read more →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
